var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 40 32",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25 17.5h9v-3h-9zm0-6h9v-3h-9zm-19 12.5h16v-.95c0-1.4-.7083-2.5417-2.125-3.425s-3.375-1.325-5.875-1.325-4.45833.4417-5.875 1.325-2.125 2.025-2.125 3.425zm7.996-8.7c1.0027 0 1.8623-.357 2.579-1.071s1.075-1.5723 1.075-2.575-.357-1.86233-1.071-2.579-1.5723-1.075-2.575-1.075-1.8623.357-2.579 1.071-1.075 1.5723-1.075 2.575.357 1.8623 1.071 2.579 1.5723 1.075 2.575 1.075zm-10.996 16.7c-.8 0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1v-26c0-.8.3-1.5.9-2.1s1.3-.9 2.1-.9h34c.8 0 1.5.3 2.1.9s.9 1.3.9 2.1v26c0 .8-.3 1.5-.9 2.1s-1.3.9-2.1.9zm0-3h34v-26h-34z",
    fill: "#fcc241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIcon2);
export default __webpack_public_path__ + "static/media/advantage-icon-2.e92a6eb638c660110586b5e95ccd2aca.svg";
export { ForwardRef as ReactComponent };